import styles from "./LearnMore.module.scss";
import { PUBLIC_IMAGE } from "../../constants";
import poolsStore from "../../stores/poolsStore";
import { observer } from "mobx-react-lite";

const LearnMore = () => {
  return (
    <div
      className={`${
        poolsStore.isSubscribe ? styles.LearnMoreNone : styles.LearnMore
      }`}
    >
      <div className={styles.LearnMore__borderTop}></div>
      <div className={styles.LearnMore__content}>
        <div className={styles.LearnMore__image}>
          <img src={PUBLIC_IMAGE + "learnMoreImg.svg"} alt="" />
        </div>
        <div className={styles.LearnMore__line}>
          <div
            className={`${styles.information__lineBox} ${styles.info__boxLeft}`}
          ></div>
          <div
            className={`${styles.information__lineBox} ${styles.info__boxRight}`}
          ></div>
          <div className={styles.information__lightBox}></div>
          <div className={styles.main__informationLogo}>
            <img src={PUBLIC_IMAGE + "Main-logoImage.svg"} alt="" />
          </div>
        </div>
        <div className={styles.LearnMore__page}>
          <div className={styles.LearnMore__title}>
            Pools and Staking for Those Who Want More
          </div>
          <div className={styles.LearnMore__text}>
            <div className={styles.LearnMore__textTitle}>
              Verified provider data
            </div>
            <div className={styles.LearnMore__textBody}>
              Compare assets, networks, providers, prices and product terms in one place.
            </div>
            <div className={styles.LearnMore__textTitle}>
              Staking and lending categories
            </div>
            <div className={styles.LearnMore__textBody}>
              Browse available staking and lending categories alongside spot and derivatives market data. No yield is promised.
            </div>
            <div className={styles.LearnMore__textTitle}>
              Transparency and security
            </div>
            <div className={styles.LearnMore__textBody}>
              All operations are transparent, data is protected, and decisions
              are based on a complete market view.
            </div>
            <div className={styles.LearnMore__textTitle}>
              Automation and convenience
            </div>
            <div className={styles.LearnMore__textBody}>
              Product actions will become available after wallet connection and final verification.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(LearnMore);
